import { CashBankAccountsResultEntity } from "../entities";
import { CashAndBankRepository } from "../repositories";

export class GetCashBankAccountsUseCase {
  constructor(private repository: CashAndBankRepository) {}

  async execute(): Promise<CashBankAccountsResultEntity> {
    return this.repository.fetchAccounts();
  }
}
